import { valueFormat } from 'components/3catinfo/Eleccions/Grafiques/GraficEleccions/dataParserEleccions';
import { useEmitter } from 'hooks/useEmitter';
import { useEffect, useMemo, useState } from 'react';
import clsx from 'clsx';
import styles from './peuEscrutini.module.scss';

const PeuEscrutini = (props) => {
    const { data, dataComparador, fase, peuMostraCamps, numColumnsRow, emitterId, peuComparadorActiu = false } = props;
    const { onEmitter } = useEmitter();
    const [showSecondaryGraph, setShowSecondaryGraph] = useState(false);

    useEffect(() => {
        if (!emitterId) return;

        onEmitter(emitterId, (value) => {
            setShowSecondaryGraph(Boolean(value));
        });
    }, [emitterId, onEmitter]);

    const activeData = peuComparadorActiu && showSecondaryGraph && dataComparador ? dataComparador : data;
    const shouldShowSeoValue = fase === 'seo' ? showSecondaryGraph && Boolean(activeData) : true;
    const camps = useMemo(
        () => ({
            electes: {
                label: 'Totals electes:',
                valor: shouldShowSeoValue ? valueFormat(fase, activeData?.num_items_total) : '-'
            },
            participacio: {
                label: 'Participació:',
                valor: shouldShowSeoValue ? valueFormat(fase, activeData?.perc_part, 2, true) : '-'
            },
            vots: {
                label: 'Vots:',
                valor: shouldShowSeoValue
                    ? valueFormat(
                          fase,
                          activeData?.opcions?.item.reduce((sum, partit) => sum + partit.vots, 0)
                      )
                    : '-'
            },
            votsBlanc: {
                label: 'En blanc:',
                valor: shouldShowSeoValue ? valueFormat(fase, activeData?.vots_blanc) : '-'
            },
            votsNuls: {
                label: 'Nuls:',
                valor: shouldShowSeoValue ? valueFormat(fase, activeData?.vots_nul) : '-'
            }
        }),
        [activeData, fase, shouldShowSeoValue]
    );

    const stylesPeu = clsx(
        styles.peu,
        numColumnsRow > 0 && styles[`col${numColumnsRow}`],
        fase === 'seo' && !showSecondaryGraph && styles.disabled
    );

    return (
        <div className={stylesPeu}>
            <div className={styles.resum}>
                {peuMostraCamps?.map((clau) => {
                    const camp = camps[clau];
                    return camp ? (
                        <div key={clau}>
                            <span className={styles.label}>{camp.label}</span> {camp.valor}
                        </div>
                    ) : null;
                })}
            </div>
        </div>
    );
};

export default PeuEscrutini;
